<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="targetTitle" width="550px">
    <div slot="content">
      <el-form :model="formData" ref="savedQueryAddForm" :rules="rules">
        <el-row :gutter="15" type="flex">
          <el-col :span="12">
            <el-form-item label="쿼리 아이디" prop="rscId">
              <el-input :disabled="(popupStatus === 'update')" @change="checkChangeFlag" placeholder="쿼리 아이디를 입력해주세요" v-model="formData.rscId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="쿼리 이름" prop="rscName">
              <el-input placeholder="쿼리 이름을 입력해주세요" @change="checkChangeFlag" v-model="formData.rscName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="수행 쿼리문" prop="queryContents">
            <el-input type="textarea" v-model="formData.queryContents" @change="checkChangeFlag" placeholder="수행 쿼리문을 입력해주세요" :rows="10" style="width: 100%"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="정렬순서">
              <el-input-number v-model="formData.orderbyIndex" @change="checkChangeFlag" controls-position="right" :min="1" :max="1000"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" class="mr-r4" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import DbmsSavedQueryApi from '@/api/settings/common/dbms-saved-query';
import msgUtil from '@/utils/message';
import { cloneDeep, isUndefined } from 'lodash';

export default {
  name: 'WSavedQuerySlidingPopup',
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      targetTitle: '',
      popupStatus: 'add',
      formData: {
        rscId: '',
        rscName: '',
        queryContents: '',
        orderbyIndex: 0,
        managetypeId: 'DBMS',
      },
      formDataOrigin: {},
      rules: {
        rscId: { required: true, trigger: 'blur', validator: this.validateForRscId },
        rscName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
      // changeFlag: false,
    };
  },
  methods: {
    open(item, popupStatus) {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs.savedQueryAddForm.resetFields();
        // this.changeFlag = false;
        if (popupStatus) {
          this.popupStatus = 'update';
          this.targetTitle = `${this.title} 수정`;
          this.formData = cloneDeep(item);
          this.formDataOrigin = cloneDeep(this.formData);
        } else {
          this.popupStatus = 'add';
          this.targetTitle = `${this.title} 추가`;
          this.formData.orderbyIndex = item.orderbyIndex;
          this.formData.rsctypeId = item.rsctypeId;
        }
      });
    },
    onSaveButton() {
      this.$refs.savedQueryAddForm.validate().then((validateRes) => {
        if (validateRes) {
          if (this.popupStatus === 'update') {
            DbmsSavedQueryApi.updateDbmsQueryInfo(this.formData).then((response) => {
              if (response.data.success) {
                this.$emit('load-data');
                this.$message(msgUtil.getCustomResultMsgData('저장이 완료되었습니다.', true));
                this.clickCloseBtn();
              }
            });
          } else {
            DbmsSavedQueryApi.insertDbmsQueryInfo(this.formData).then((response) => {
              if (response.data.success) {
                this.$emit('load-data');
                this.$message(msgUtil.getCustomResultMsgData('저장이 완료되었습니다.', true));
                this.clickCloseBtn();
              }
            });
          }
        }
      }).catch(() => {
      });
    },
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    checkChangeFlag() {
      // 값 입력 체크시 아래 주석 풀고 사용할 것
      // this.changeFlag = !isEqual(this.formData, this.formDataOrigin);
    },
    // 중복 아이디 검사
    validateForRscId(rule, value, callback) {
      if (isUndefined(value) || value === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (this.popupStatus === 'add') {
        DbmsSavedQueryApi.validateForRscId(this.formData).then((response) => {
          if (response.data.data) {
            callback();
          } else {
            callback(new Error('이미 사용 중인 아이디입니다.'));
          }
        });
      } else if (this.popupStatus === 'update') {
        callback();
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/database/SavedQuery/popup/SavedQuerySlidingPopup.vue